import { useCallback } from 'react';
import { PersonalInsuranceRiskPackage } from '@app/domain/model/eshop/personal-accidents/PersonalInsuranceRiskPackage';
import { trackAddToCart } from '@app/infrastructure/gtm/personal-accidents/trackAddToCart';
import { PA_INSURANCE_STEPS } from '@app/app/esales/personal-accidents/_sections/steps/PA_INSURANCE_STEPS';

interface UsePersonalAccidentsGtmTrackingParams {
    selectedRisk?: PersonalInsuranceRiskPackage;
}

interface TrackStepCompletionParams {
    currentStepKey: string;
}

export function usePersonalAccidentsGtmTracking({ selectedRisk }: UsePersonalAccidentsGtmTrackingParams) {
    const trackStepCompletion = useCallback(
        ({ currentStepKey }: TrackStepCompletionParams) => {
            if (currentStepKey !== PA_INSURANCE_STEPS.CHOOSE_INSURANCE) {
                return;
            }

            trackAddToCart(selectedRisk);
        },
        [selectedRisk],
    );

    return {
        trackStepCompletion,
    };
}
